export default __webpack_public_path__ + "static/media/cvod-R18.f84c659b.svg";